import "react-perfect-scrollbar/dist/css/styles.css";
import React from "react";
import { createBrowserHistory } from "history";
import { create } from "jss";
import rtl from "jss-rtl";
import { ThemeProvider, jssPreset, StylesProvider } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";

import GlobalStyles from "src/components/GlobalStyles";
import { AuthProvider } from "src/contexts/JWTAuthContext";
import { AppInfoProvider } from "src/contexts/AppInfo";
import "src/mixins/chartjs";
import theme from "src/theme";
import routes, { renderRoutes } from "src/routes";
import { SnackbarProvider } from "notistack";

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
export const history = createBrowserHistory();

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <StylesProvider jss={jss}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <SnackbarProvider dense maxSnack={3}>
            <AppInfoProvider>
              <AuthProvider>
                <GlobalStyles />
                {renderRoutes(routes)}
              </AuthProvider>
            </AppInfoProvider>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
  );
};

export default App;
